import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MdAdd, MdDelete, MdSearch } from 'react-icons/md';
import axiosInstance from '../../api/axiosInstance';

const GalleryList = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const response = await axiosInstance.get('/gallery');
        setImages(response.data.data || []);
      } catch (err) {
        console.error('Failed to fetch gallery:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchGallery();
  }, []);

  const filteredImages = images.filter((img) => {
    const titleText = img.name || img.title || '';
    return titleText.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this image?')) {
      try {
        await axiosInstance.delete(`/gallery/${id}`);
        const response = await axiosInstance.get('/gallery');
        setImages(response.data.data || []);
      } catch (err) {
        alert('Failed to delete image');
        console.error('Delete error:', err);
      }
    }
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">Gallery</h1>
        <Link
          to="/admin/gallery/create"
          className="flex items-center justify-center gap-2 bg-[#008300] text-white px-4 py-2 rounded-lg hover:bg-[#006600] transition-colors"
        >
          <MdAdd />
          <span>Upload Image</span>
        </Link>
      </div>

      {/* Search */}
      <div className="mb-6">
        <div className="relative">
          <MdSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search images..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#008300] focus:border-transparent outline-none"
          />
        </div>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="text-center py-12 text-gray-500">
          Loading gallery...
        </div>
      )}

      {/* Image Grid */}
      {!loading && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {filteredImages.map((img) => (
            <div
              key={img.id}
              className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 hover:shadow-md transition-shadow"
            >
              <img
                src={img.image}
                alt={img.name || img.title || 'Gallery Image'}
                className="w-full h-36 sm:h-48 object-cover"
              />
              <div className="p-3 sm:p-4">
                <h3 className="font-semibold text-gray-800 mb-1 text-sm sm:text-base">{img.name || img.title || 'Untitled'}</h3>
                {img.category && <p className="text-xs sm:text-sm text-gray-500 mb-3">{img.category}</p>}
                <button
                  onClick={() => handleDelete(img.id)}
                  className="w-full py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors text-sm sm:text-base"
                >
                  <MdDelete className="inline mr-1" />
                  Delete
                </button>
              </div>
            </div>
          ))}
          {filteredImages.length === 0 && (
            <div className="col-span-full text-center py-12 text-gray-500">
              No images found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default GalleryList;
